export default __webpack_public_path__ + "static/media/flash-slash.597e9742.svg";